var $6540a12b04d0ea39$exports = {};
$6540a12b04d0ea39$exports = {
    "replaceMessage": `\u{41F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{449}\u{438}\u{442}\u{435} \u{444}\u{430}\u{439}\u{43B} \u{434}\u{43B}\u{44F} \u{437}\u{430}\u{43C}\u{435}\u{43D}\u{44B}`
};


export {$6540a12b04d0ea39$exports as default};
//# sourceMappingURL=ru-RU.mjs.map
